(function () {
  const openBtn = document.getElementById('open-bundle-modal');
  const modal = document.getElementById('bundle-modal');
  const closeBtn = document.getElementById('close-bundle-modal');
  const selectorsDiv = document.getElementById('bundle-selectors');
  const addBtn = document.getElementById('bundle-add-to-cart');
  const errorMsg = document.getElementById('bundle-error');

  if (!openBtn || !modal) return;

  let variants = [];
  let options = [];
  let product = [];

  // Hardcoded encoded handle — avoids any encoding issues
  const encodedHandle = 'facebrella%E2%84%A2-facebrella%E2%84%A2-tints-eyebrella%E2%84%A2-lipbrella%E2%84%A2-double-ended-brush';

  fetch(`/products/${encodedHandle}.js`)
    .then(function(r) { return r.json(); })
    .then(function(product) {
      variants = product.variants;
      options = product.options;
      product = product;
      // options is an array of objects: { name, position, values[] }
      renderSelectors();
    })
    .catch(function(err) {
      selectorsDiv.innerHTML = '<p style="color:red;">Could not load shades. Please try again.</p>';
      console.error('Bundle fetch error:', err);
    });    

  function renderSelectors() {
    selectorsDiv.innerHTML = '';    

    options.forEach(function(option, i) {
      // option = { name: "EYEBRELLA ...", position: 1, values: ["Fair", "Light", ...] }
      var wrapper = document.createElement('div');
      wrapper.style.marginBottom = '16px';

      var label = document.createElement('label');
      label.style.cssText = 'display:block; font-weight:bold; margin-bottom:6px; font-size:14px;';
      label.textContent = option.name;

      var select = document.createElement('select');
      select.setAttribute('data-option-index', i);
      select.style.cssText = 'width:100%; padding:10px; border-radius:6px; border:1px solid #ccc; font-size:15px;';

      option.values.forEach(function(value) {
        var opt = document.createElement('option');
        opt.value = value;
        opt.textContent = value;
        select.appendChild(opt);
      });

      wrapper.appendChild(label);
      wrapper.appendChild(select);
      selectorsDiv.appendChild(wrapper);
    });

    addBtn.disabled = false;
  }

  function getSelectedVariant() {
    var selects = selectorsDiv.querySelectorAll('select');
    var selected = Array.from(selects).map(function(s) { return s.value; });
    return variants.find(function(v) {
      return selected.every(function(val, i) {
        return v['option' + (i + 1)] === val;
      });
    });
  }

  openBtn.addEventListener('click', function() {
    modal.style.display = 'flex';
    errorMsg.style.display = 'none';
  });

  closeBtn.addEventListener('click', function() {
    modal.style.display = 'none';
  });

  modal.addEventListener('click', function(e) {
    if (e.target === modal) modal.style.display = 'none';
  });

  addBtn.addEventListener('click', async function() {
    var variant = getSelectedVariant();
    errorMsg.style.display = 'none';

    if (!variant || !variant.available) {
      errorMsg.style.display = 'block';
      return;
    }

    addBtn.textContent = 'Adding…';
    addBtn.disabled = true;

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variant.id, quantity: 1 })
      });
      window.location.href = '/cart';
    } catch(e) {
      addBtn.textContent = 'Add to Cart';
      addBtn.disabled = false;
      errorMsg.textContent = 'Something went wrong. Please try again.';
      errorMsg.style.display = 'block';
    }
  });

})();